import React from "react";
import { Link } from "react-router-dom";
import ProfileLayout from "../../components/profile-redesign/ProfileLayout";
import Panel from "../../components/profile-redesign/Panel";
import Notice from "../../components/profile-redesign/Notice";
import StateMessage from "../../components/profile-redesign/StateMessage";
import {
  useProfile,
  useProfileOrders,
} from "../../components/profile-redesign/useProfile";
import { useOrderAddresses } from "../../components/profile-redesign/useOrderAddresses";
import { orderRef } from "../../components/profile-redesign/profileData";

function ProfileAddresses() {
  const { user, isLoading, isError, signOut } = useProfile();
  const { orders, isFetching, isEmpty } = useProfileOrders(user?._id);
  const { addresses, isLoading: loadingAddresses } = useOrderAddresses(orders);

  const body = () => {
    if (isFetching || loadingAddresses) {
      return <StateMessage tone="loading" title="Loading your addresses…" />;
    }

    if (isEmpty || !addresses.length) {
      return (
        <StateMessage
          title="No addresses yet"
          text="Your address book fills in from the delivery and billing details you use at checkout."
        >
          <div className="c4prf__actions">
            <Link
              className="c4prf__btn c4prf__btn--primary"
              to={process.env.PUBLIC_URL + "/shop-grid-standard"}
            >
              Start Shopping
            </Link>
          </div>
        </StateMessage>
      );
    }

    return (
      <ul className="c4prf__cards">
        {addresses.map((address) => (
          <li className="c4prf__card" key={address.id}>
            <div className="c4prf__card-head">
              <span className="c4prf__card-label">{address.label}</span>
            </div>

            {address.name ? (
              <p className="c4prf__card-name">{address.name}</p>
            ) : null}
            <p className="c4prf__card-lines">{address.lines}</p>
            {address.phone ? (
              <p className="c4prf__card-phone">{address.phone}</p>
            ) : null}

            <p className="c4prf__card-foot">
              Used on order {orderRef(address.orderId)}
            </p>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <ProfileLayout
      seoTitle="Saved Addresses"
      title="Saved Addresses"
      subtitle="The delivery and billing addresses you've used before."
      user={user}
      isLoading={isLoading}
      isError={isError}
      onSignOut={signOut}
    >
      <Panel id="c4prf-addresses" title="Address Book">
        {body()}
      </Panel>

      <Notice>
        This book is built from your past orders, so it's read-only. Saving,
        editing or setting a default address needs an address endpoint on the
        API — until then, enter the address you want at checkout and it will
        show up here afterwards.
      </Notice>
    </ProfileLayout>
  );
}

export default ProfileAddresses;
